import axios from 'axios'
import qs from 'qs'

// 配置请求环境
let apiUrl = ''
let baseUrl = ''
let bmsBaseUrl = ''
let HOST = process.env.HOST

apiUrl = (HOST === 'test' || HOST === 'dev') ? 'https://store.asiacuanon.cn/' : 'https://store.asia-paints.com/'
baseUrl = HOST === 'dev' ? '/api' : HOST === 'test' ? 'https://store.asiacuanon.cn/api' : 'https://store.asia-paints.com/api'


bmsBaseUrl = HOST === 'dev' ? '/bmsApi' : HOST === 'test' ? 'https://newretail-m-seller-api.asiacuanon.cn/api' : 'https://newretail-m-seller-api.cuanon.com/api'
// axios.defaults.baseURL = apiUrl
// if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
//     // 本地开发或者测试环境
//     axios.defaults.baseURL = 'https://store-h5.asiacuanon.cn'
// } else if (process.env.NODE_ENV === 'production') {
//     // 生产环境
//     axios.defaults.baseURL = 'https://store-h5.asia-paints.com'
// } else {
//     axios.defaults.baseURL = 'https://store-h5.asiacuanon.cn'
// }

axios.defaults.timeout = 10000 // 设置请求10秒后请求超时

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
    config => {
        const toekn = sessionStorage.getItem('token')
        config.headers.token = toekn

        return config
    },
    error => {
        console.log(error)
        return Promise.error(error)
    }
)

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        if (error.response.status) {
            // switch (error.response.status) {
            //     // 401: 未登录
            //     // 未登录则跳转登录页面，并携带当前页面的路径
            //     // 在登录成功后返回当前页面，这一步需要在登录页操作。
            //     case 401:
            //         router.replace({
            //             path: '/login',
            //             query: {
            //                 redirect: router.currentRoute.fullPath
            //             }
            //         });
            //         break;

            //     // 403 token过期
            //     // 登录过期对用户进行提示
            //     // 清除本地token和清空vuex中token对象
            //     // 跳转登录页面
            //     case 403:
            //          Toast({
            //             message: '登录过期，请重新登录',
            //             duration: 1000,
            //             forbidClick: true
            //         });
            //         // 清除token
            //         localStorage.removeItem('token');
            //         store.commit('loginSuccess', null);
            //         // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            //         setTimeout(() => {
            //             router.replace({
            //                 path: '/login',
            //                 query: {
            //                     redirect: router.currentRoute.fullPath
            //                 }
            //             });
            //         }, 1000);
            //         break;

            //     // 404请求不存在
            //     case 404:
            //         Toast({
            //             message: '网络请求不存在',
            //             duration: 1500,
            //             forbidClick: true
            //         });
            //         break;
            //     // 其他错误，直接抛出错误提示
            //     default:
            //         Toast({
            //             message: error.response.data.message,
            //             duration: 1500,
            //             forbidClick: true
            //         });
            // }
            return Promise.reject(error.response)
        }
    }
)

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(`${baseUrl}/${url}?${qs.stringify(params)}`)
        .then(res => {
            resolve(res.data)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(`${baseUrl}/${url}`, params)
        .then(res => {
            resolve(res.data)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export function bmsget(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(`${bmsBaseUrl}/${url}?${qs.stringify(params)}`)
        .then(res => {
            resolve(res.data)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export function bmsPost(url, params) {
  return new Promise((resolve, reject) => {
      axios.post(`${bmsBaseUrl}/${url}`, params)
      .then(res => {
          resolve(res.data)
      })
      .catch(err => {
          reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js